import { ACTIVE_LANGUAGE_CODE, EN, DE } from './constants';

// api config!
const backendHost = process.env.REACT_APP_API_URL;
const languageCode = ACTIVE_LANGUAGE_CODE === DE ? DE : EN;
export const HOST_ROOT = `${backendHost}`;
export const API_ROOT = `${backendHost}/api`;
export const ACCEPT_LANGUAGE_HEADER = { headers: { 'Accept-Language': languageCode } };
